<template>
  <div class="application-list-page">
    <div class="container">
      <div class="application-block">
        <div class="profile-content">
          <div class="row">
            <div class="col-md-5">
              <h2>{{ Number(archived) === 1 ? 'Архив заявок на судозаход' : 'Заявки на судозаход' }}</h2>
            </div>
            <div class="col-md-7" v-if="['trusted_user', 'user', 'manager'].includes(user.role)">
              <router-link class="btn btn-primary pull-right profile-new-app" :to="{ name: 'CreateVTS' }">
                Создать новую заявку
              </router-link>
            </div>
          </div>

          <hr>

          <div class="row filters-block">
            <div :class="{
              'col-md-3' : ['sb', 'sb_truck', 'sb_other'].includes(user.role),
              'col-md-6' : !['sb', 'sb_truck', 'sb_other'].includes(user.role)
            }"
            >
              <div class="row">
                <b-input-group>
                  <b-form-input ref="searchBar"
                         v-model="search"
                         placeholder="Поиск по заявкам"
                         type="text"
                         @keyup.enter="changeSearch"
                  />
                  <b-input-group-append>
                    <button class="btn btn-default"
                            type="button"
                            @click="sendSearch($event)"
                    >
                      <b-icon-search/>
                    </button>
                    <b-dropdown id="columns-filter-button" variant="outline" style="z-index: 1"
                    :toggle-class="'btn-default'"
                    >
                      <template #button-content>
                        <b-icon-filter/>
                      </template>
                      <b-dropdown-item v-for="(label, column) in filterColumns"
                        :key="column"
                        :value="column"
                        @click="handleFilter(column)"
                      >
                        {{ label }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div class="row">
                <div class="active-filter">
                  <small>
                    <b-icon-filter/>
                    <b id="active-filter">
                      {{ selectedColumnFilter }}
                    </b>
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-3 filter-input-block">
              <select id="search-filter" v-model="searchStatus"
                      :disabled="user.role === 'guard'"
                      class="show-tick form-control"
                      @change="handleStatus($event)"
              >
                <option value="all">
                  Все статусы
                </option>
                <option v-for="(status, key) in statuses"
                        :key="key"
                        :value="key"
                >
                  {{ status.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="applications && applications.length">
            <div class="row">
              <div class="col-md-12">
                <div v-for="(application, index) in applications"
                     :key="index"
                     :class="applicationCSSClass(application)"
                     class="application-list">
                  <application-item
                    :application=application
                    :application-index="index"
                    :pagination="pagination"
                    :statuses="statuses"
                    :port-sail-type-cost="portSailTypeCost"
                  />
                </div>
                <infinite-loading
                  v-if="visibleInfiniteLoading"
                  :identifier="infiniteId"
                  @infinite="infiniteLoadApplications"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <br>
            <p class="text-center">Заявок нет</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XlsExport from '@/components/application/XlsExport.vue'
import ApplicationItem from '@/components/application/ApplicationItem.vue'
import axios from 'axios'
import ApplicationClient from '@/common/helpers/api-client/Application'

export default {
  name: 'ApplicationList',
  components: { ApplicationItem, XlsExport },
  data: function () {
    return {
      canFocusToSearchBar: true,
      canInfinite: true,
      filterColumns: ['all'],
      filterColumn: 'number',
      types: [],
      archived: 0, // data.archived,
      searchStatus: 'all', // data.searchStatus,
      typeFilter: 'all', // data.typeFilter,
      subdivFilter: 'all', // data.subdivFilter,
      search: '', // data.search,
      pagination: {
        per: 5,
        active: 1,
        count: 0
      },
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      access: 0, // data.access,
      preloader: true,
      applications: [],
      notifications: null, // data.notifications,
      support: {
        sending: false,
        form: {
          action: 'support',
          category_id: 0,
          theme: '',
          message: ''
        },
        errors: []
      },
      saveFieldData: {
        code: '',
        error: false
      },
      signers: {},
      exportModel: 'application',
      xlsStatus: '',
      infiniteId: 0,
      alertType: '',
      statuses: [],
      portSailTypeCost: []
    }
  },

  computed: {
    applicationsCount () {
      return this.pagination.count
    },

    applicationsPagination () {
      return this.applications
    },

    filterParams () {
      const search = this.search
      const filter = this.searchStatus
      const typeFilter = this.typeFilter
      const subdivFilter = this.subdivFilter
      const archived = this.archived
      const filterColumn = this.filterColumn
      const page = this.pagination.active

      return {
        archived,
        search,
        filter,
        typeFilter,
        subdivFilter,
        filterColumn,
        page
      }
    },

    isSearching () {
      return this.search || this.searchStatus !== 'all' || this.typeFilter !== 'all' ||
        this.subdivFilter !== 'all' ||
        (this.filterColumns.length > 0 && this.filterColumns !== '0')
    },

    selectedColumnFilter () {
      return this.filterColumns[this.filterColumn] ?? 'Все поля'
    },

    visibleInfiniteLoading () {
      return this.pagination.active < this.countPages() && this.pagination.active > 0
    },

    xlsImportAllowed () {
      return (
        this.search ||
        this.searchStatus !== 'all' ||
        this.typeFilter !== 'all' ||
        this.subdivFilter !== 'all'
      ) && this.applications && this.applications.length > 0
    }
  },

  created () {
    const vue = this
    this.pagination.active = this.$route.query?.page ?? 1

    this.handleCurrentPage()
    this.insertSearchParams()
    this.fetchData()
    this.hidePreloader()

    window.addEventListener('popstate', (event) => {
      if (event.state) {
        vue.fillSearchParamsFromState(event.state)
        vue.sendSearch()
      }
    })
  },

  methods: {
    applicationCSSClass (application) {
      return 'profile-application-color-' + application.status
    },

    canAcceptForApproval (application) {
      return application.status !== 'draft' &&
        this.user &&
        application.status === 'subdivision_yes' &&
        ['sb', 'sb_truck', 'sb_other'].includes(this.user.role) &&
        (application.visitorCount - application.visitorCloseCount) > 0
    },

    canApproval (application) {
      if (['begin', 'notactive'].includes(application.status) &&
        this.isAgentOwner(application)) {

        return true
      }

      const subdivision = this.user.subdivisions && this.user.subdivisions.find(
        _subdivision => _subdivision.subdivision_id === application.subdivision_id
      )
      if (['sb', 'sb_truck', 'sb_other'].includes(this.user.role) && subdivision && application.status === 'begin') {
        return true
      }

      return (application.visitorCount - application.visitorCloseCount) > 0 &&
        ['subdivision'].includes(this.user.role) &&
        ['agent_yes', 'begin', 'notactive'].includes(application.status)
    },

    canTransferToBorderService (application) {
      return application.status !== 'draft' &&
        this.user &&
        ['sb_begin'].includes(application.status) &&
        ['sb', 'sb_truck', 'sb_other'].includes(this.user.role) &&
        (application.visitorCount - application.visitorCloseCount) > 0 &&
        application.step === 'state'
    },

    changeSearch (event) {
      this.search = event.target.value
      this.insertSearchParams()
      this.sendSearch(event)
    },

    changeXlsStatus (status, type) {
      this.xlsStatus = status
      this.alertType = type
      return status
    },

    countPages () {
      return Math.ceil(this.pagination.count / this.pagination.per)
    },

    deleteApplication (application) {
      if (confirm('Удалить заявку? Она покинет нас навсегда')) {
        window.location.href = this.url('profile/delete?id=' + application.id +
          '&archived=' + this.archived + '&page=' + this.pagination.active + '&filter=' + this.searchStatus +
          '&typeFilter=' + this.typeFilter + '&subdivFilter=' + this.subdivFilter + '&pageCount=' + Number(this.pagination.count))
      }
    },

    async fetchData () {
      this.statuses = await ApplicationClient.statuses()
      this.portSailTypeCost = await ApplicationClient.portCost()
      const filters = await ApplicationClient.filters()
      this.filterColumns = filters.filterColumns ?? []
      this.types = filters.types ?? []
    },

    fillSearchParamsFromState ({ search, filter, typeFilter, subdivFilter, archived, filterColumn, page }) {
      this.search = search ?? this.search
      this.searchStatus = filter ?? this.searchStatus
      this.typeFilter = typeFilter ?? this.typeFilter
      this.subdivFilter = subdivFilter ?? this.subdivFilter
      this.archived = archived ?? this.archived
      this.filterColumn = filterColumn ?? this.filterColumn
      this.pagination.active = page ?? this.pagination.active
    },

    firstPage () {
      this.pagination.active = 1
      this.replaceStatePageData()
    },

    async getPageApplications (activePage, perPage = null) {
      let results = []

      await ApplicationClient.applicationList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        search: this.search,
        status: this.searchStatus,
        type: this.typeFilter,
        subdivision: this.subdivFilter,
        archived: this.archived,
        filterColumn: this.filterColumn
      }).then((response) => {
        this.pagination.count = response?.data?.data?.count
        results = response?.data?.data?.models
      })

      return results
    },

    async handleCurrentPage () {
      this.fillSearchParamsFromState(this.$route.query)

      if (this.pagination.active > 1 && this.applications.length <= this.pagination.per) {
        this.canFocusToSearchBar = false
        this.canInfinite = false

        const needleCount = this.pagination.active * this.pagination.per
        this.applications = await this.getPageApplications(1, needleCount)
      } else {
        this.applications = await this.getPageApplications(this.pagination.active)
      }
    },

    handleFilter (value) {
      this.filterColumn = value
      this.insertSearchParams()
      this.sendSearch()
    },

    handleStatus (value) {
      if (value.length !== 0) {
        this.insertSearchParams()
      }
      this.sendSearch()
    },

    handleSubdivision (value) {
      if (value.length !== 0) {
        this.insertSearchParams()
      }
      this.sendSearch()
    },

    handleType (value) {
      if (value.length !== 0) {
        this.insertSearchParams()
      }
      this.sendSearch()
    },

    infiniteLoadApplications ($state) {
      const _this = this

      setTimeout(async function () {
        if (_this.pagination.active < _this.countPages() && _this.pagination.active > 0) {
          if (!_this.canInfinite) {
            $state.loaded()
            _this.canInfinite = true

            return
          }

          _this.pagination.active++

          const applications = await _this.getPageApplications(_this.pagination.active)
          if (applications.length) {
            _this.applications.push(...applications)
            $state.loaded()
          } else {
            $state.complete()
          }

          // Vue.nextTick(function () {
          //   //$('[data-toggle="tooltip"]').tooltip()
          // }) TODO

          _this.replaceStatePageData()
        }
      }, 100)
    },

    insertSearchParams () {
      this.updateUrlHash(this.filterParams)
    },

    isAgentOwner (application) {
      return this.user.role === 'agent' &&
        application.agent_organization_id === this.user.organization_id
    },

    isAgentPrime () {
      return this.user.role === 'agent_prime'
    },

    replaceStatePageData () {
      const params = history.state ?? this.filterParams
      params.page = this.pagination.active

      const url = new URL(window.location)
      url.searchParams.set('page', this.pagination.active)
      history.replaceState(params, undefined, url.href)
    },

    async sendSearch (event) {
      this.firstPage()
      this.infiniteId += 1

      this.applications = await this.getPageApplications(this.pagination.active)
      // this.getSigners()
    },

    async sendSolvoXml (appId) {
      await axios({
        method: 'post',
        url: this.baseUrl + '/api/v1/xml/solvo-xml',
        type: 'post',
        dataType: 'json',
        headers: { Authorization: `Bearer ${localStorage.accessToken}` },
        data: {
          appId
        }
      }).then(function (result) {
        if (result.data.http_code === 200) {
          alert('Заявка успешно передана в Solvo.TOS')
          setTimeout(
            function () {
              window.location.reload()
            }, 1000)
        } else {
          alert('Не удалось передать в Solvo.TOS')
          console.log(result.data)
        }
      }).catch(function (xhr) {
        console.log(xhr)
      })
    },

    updateUrlHash (data) {
      const url = new URL(window.location)
      Object.keys(data).forEach(function (item) {
        url.searchParams.set(item, data[item])
      })
      window.history.pushState(data, '', url.href)
    },

    url (url) {
      return this.baseUrl + '/' + url
    }
  }
}
</script>
